import React from 'react';
import PropTypes from 'prop-types';
import * as S from './ActionIcons.styles';
import { useTheme } from 'styled-components';
import { EditIcon, CloseIcon } from '@edusynch/edusynch-svg-icons';

const ActionIcons = ({ onEdit, onDelete }) => {
  const theme = useTheme();

  return (
    <S.Container>
      <button type="button" onClick={onEdit}>
        <EditIcon width={14} color={theme.config.colors.default} />
      </button>

      <button type="button" onClick={onDelete}>
        <CloseIcon width={14} color={theme.config.colors.default} />
      </button>
    </S.Container>
  );
};

ActionIcons.propTypes = {
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
};

export default ActionIcons;
